var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEMailLightClosedEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.131 24h16.04C25.965 24 27 23.034 27 21.121V10.87C27 8.966 25.954 8 23.872 8H7.832C6.035 8 5 8.956 5 10.87V21.12C5 23.044 6.049 24 8.131 24zm6.686-7.531L7.292 9.55c.22-.084.479-.13.778-.13h15.863c.309 0 .577.046.797.14l-7.502 6.908c-.43.4-.817.575-1.206.575-.398 0-.787-.185-1.205-.575zm-8.29 4.652V10.767l5.727 5.247-5.717 5.265a.824.824 0 0 1-.01-.158zM25.476 10.88V21.25l-5.688-5.237 5.688-5.219zM8.07 22.579c-.28 0-.52-.037-.726-.12l5.959-5.489.647.595c.695.64 1.364.91 2.072.91.695 0 1.374-.27 2.073-.91l.647-.595 5.946 5.48c-.216.092-.465.129-.755.129z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMailLightClosedEnvelope);
export default __webpack_public_path__ + "static/media/eMail-Light--Closed-Envelope.01a47a059a7641a5227c550dfab82706.svg";
export { ForwardRef as ReactComponent };